import React from "react";
import "./styles.scss";
import image from "../../../../assets/images/card_1_htp.png";
import { useTheme } from "../../../../hook/useThemes";

export default function Card1() {
  const {lang} = useTheme()
  return (
    <div className="wrap-cart-how-to-play wrap-cart-how-to-play-1">
        <div className="wrap-title-step">
            {lang?.step_1 || "Step 1"}
        </div>
      <p className="label">
        {lang?.how_to_play_1 || "Place a bet on whether the Bitcoin price will go up or down by the end of the next round."}
      </p>
      <img src={image} alt="img" className="image-h_t_play" />
    </div>
  );
}
